export default (func, limit = 1000) => {
  let prevFunc
  let prevRun

  return (...args) => {
    const doFunc = () => {
      func.apply(null, args)
      prevRun = Date.now()
    }

    if (!prevRun) {
      doFunc()
    } else {
      clearTimeout(prevFunc)
      prevFunc = setTimeout(() => {
        if (Date.now() - prevRun < limit) return
        doFunc()
      }, limit - (Date.now() - prevRun))
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/throttle.js